// extracted by mini-css-extract-plugin
export var sliderRange = "_p3-2";
export var sliderRoot = "_p3-0";
export var sliderThumb = "_p3-3";
export var sliderTrack = "_p3-1";